/* eslint-disable */
import { SubscriptionsApiParameter, updateSubscriptionWithResult } from "@auer-steel/Services/SubscriptionService";
import throwErrorIfTesting from "@insite/client-framework/Common/ThrowErrorIfTesting";
import { ApiHandler, createHandlerChainRunner, HasOnSuccess } from "@insite/client-framework/HandlerCreator";

type UpdateSubscriptionParameter = {
    onError?: (error: string) => void;
} & SubscriptionsApiParameter &
    HasOnSuccess<SubscriptionsApiParameter>;

type HandlerType = ApiHandler<UpdateSubscriptionParameter, string>;

export const PopulateApiParameter: HandlerType = props => {
    throwErrorIfTesting();

    props.apiParameter = props.parameter;
};

export const SendDataToApi: HandlerType = async props => {
    const result = await updateSubscriptionWithResult(props.apiParameter);
    if (result.successful) {
        props.apiResult = "Subscription complete.";
    } else {
        props.parameter.onError?.(result.errorMessage);
        return false;
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.(props.apiParameter);
};

export const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback];

// TODO: Rename to AuerUpdateSubscription
const updateSubscription = createHandlerChainRunner(chain, "UpdateSubscription");
export default updateSubscription;
